import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { getAccountScopeUserSettings } from 'owa-session-store';
import type { ReadOnlyAccountConfiguration } from 'owa-session-store';

export const getAccountScopeUserConfiguration = ():
    | ReadOnlyAccountConfiguration
    | Record<string, never> => getAccountScopeUserSettings(getUserMailboxInfo()) ?? {};
